const createDeclarationApprovalController = () => Object.freeze({
    flush() {
        return Promise.resolve()
    },
})

export { createDeclarationApprovalController }
export default createDeclarationApprovalController
